import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { pairFlights } from "../../../../../store/selectors";
import { useTypedSelector } from "../../../../../store/store";

import { FlightItemPair } from "./flight-item-pair";
import styles from "./index.module.scss";

export const Flights = () => {
  const { t } = useTranslation();

  const reservation = useTypedSelector(
    (state) => state.reservation.reservation,
  );

  const pairs = useMemo(
    () => pairFlights(reservation?.flights ?? []),
    [reservation?.flights],
  );

  if (!pairs.length) {
    return null;
  }

  return (
    <div className={styles.tableContainer}>
      <h2 className={styles.tableContainer_title}>{t("flights")}</h2>

      <div className={styles.flights}>
        {pairs.map((pair) => {
          const { outbound, inbound } = pair;

          return (
            <FlightItemPair
              key={pair.outbound.id}
              outbound={outbound}
              inbound={inbound}
            />
          );
        })}
      </div>
    </div>
  );
};
